var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":{ 'is-primary': !_vm.isFollowed, 'is-danger': _vm.isFollowed },"size":"is-small"},nativeOn:{"click":function($event){return _vm.onclick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.isFollowed ? "已经关注" : "关注"))])}
var staticRenderFns = []

export { render, staticRenderFns }